<template>
  <div class="report-detail-container">
    <header class="header-content">
      <h1 class="main-title">积沙成塔</h1>
      <p class="sub-title">🌱成长，藏在每一次坚持里</p>
    </header>

    <section class="content-section">
      <p class="body-text">认真完成的每一道题，</p>
      <p class="body-text">都在积累知识，也在塑造能力。</p>
      <p class="body-text">坚持学习，终会迎来属于自己的收获。</p>
      
      <div class="stats-card">
        <div class="stats-item" v-show="ReportData.coursenumMon">
          <span class="stats-label">学习了</span>
          <span class="stats-number">{{ ReportData.coursenumMon }}</span>
          <span class="stats-unit">门课程</span>
        </div>

        <div class="stats-item" v-show="ReportData.coursenum">
          <span class="stats-label">完成了</span>
          <span class="stats-number">{{ ReportData.coursenum }}</span>
          <span class="stats-unit">门课程</span>
        </div>

        <div class="stats-item" v-show="ReportData.examTimes">
          <span class="stats-label">累计考试</span>
          <span class="stats-number">{{ ReportData.examTimes }}</span>
          <span class="stats-unit">次</span>
        </div>

        <div class="stats-item" v-show="ReportData.creditvalue">
          <span class="stats-label">获得学分</span>
          <span class="stats-number">{{ ReportData.creditvalue }}</span>
          <span class="stats-unit">分</span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: ["ReportData"],
}
</script>

<style scoped>
.report-detail-container {
  width: 100%;
  height: 100vh;
  background: 
    url("../../assets/26July/logo.png") right top no-repeat,
    url("../../assets/26July/bg.jpg") no-repeat;
  background-size: 100% 100%, cover;
  color: #000;
  padding: 0 10%;
  box-sizing: border-box;
  overflow: hidden;
}

.header-content {
  padding-top: 8vh;
  margin-bottom: 3vh;
  text-align: center;
}

.main-title {
  font-size: 36px;
  font-weight: 800;
  margin: 0;
  color: #2d3748;
  letter-spacing: 4px;
}

.sub-title {
  font-size: 20px;
  font-weight: 600;
  color: #5C2E2E;
  margin-top: 12px;
  opacity: 0.85;
}

.content-section {
  text-align: center;
}

.body-text {
  font-size: 17px;
  line-height: 1.8;
  color: #333;
  margin: 6px 0;
  font-weight: 400;
}

.stats-card {
  margin-top: 30px;
  background: rgba(255, 255, 255, 0.55);
  backdrop-filter: blur(15px);
  border-radius: 24px;
  padding: 24px 28px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.4);
}

.stats-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 0;
  border-bottom: 1px solid rgba(0, 135, 119, 0.1);
}

.stats-item:last-child {
  border-bottom: none;
}

.stats-label {
  font-size: 18px;
  font-weight: 500;
  color: #333;
}

.stats-number {
  font-size: 36px;
  font-weight: 900;
  color: #2c80da;
  font-family: 'Arial Black', sans-serif;
  margin: 0 6px;
}

.stats-unit {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

@media screen and (min-width: 786px) {
  .report-detail-container {
    background-image: url("../../assets/26July/pcbg.png");
    background-size: cover;
  }

  .main-title {
    font-size: 48px;
  }

  .sub-title {
    font-size: 24px;
  }

  .stats-card {
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>